// ============================================================================
// utils_device.ts
// Couleurs devices, stats, détection protocole URL.
// ============================================================================

import { DeviceWebRTCStats } from './types_webrtc';

// ─── Couleurs ─────────────────────────────────────────────────────────────────

const DEVICE_COLORS = ['#00aaff','#ff6b35','#a78bfa','#34d399','#fb923c','#f472b6','#38bdf8','#4ade80'];

/**
 * Factory — permet d'instancier plusieurs résolveurs indépendants
 * (tests, multi-instance). L'export direct `getDeviceColor` reste disponible
 * comme singleton de commodité.
 */
export const createDeviceColorResolver = () => {
  const map = new Map<string, string>();
  let idx = 0;
  return (deviceId: string): string => {
    if (!map.has(deviceId)) map.set(deviceId, DEVICE_COLORS[idx++ % DEVICE_COLORS.length]);
    return map.get(deviceId)!;
  };
};

export const getDeviceColor      = createDeviceColorResolver();
export const getDeviceColorRegie = getDeviceColor; // alias rétro-compat

// ─── Stats ────────────────────────────────────────────────────────────────────

export const formatDeviceStats = (stats: DeviceWebRTCStats): string => {
  const mb = (stats.bytes / 1024 / 1024).toFixed(2);
  return `${mb} MB · ${stats.packets} paquets`;
};

// ─── Protocole URL ────────────────────────────────────────────────────────────

export type UrlProtocol = 'hls' | 'dash' | 'native' | 'unsupported';

export const detectUrlProtocol = (url: string): UrlProtocol => {
  const u = url.toLowerCase();
  if (u.includes('.m3u8') || u.startsWith('hls+'))  return 'hls';
  if (u.includes('.mpd')  || u.startsWith('dash+')) return 'dash';
  if (/^(rtsp|rtsps|rtmp|rtmps|srt):\/\//.test(u)) return 'unsupported';
  return 'native';
};